import * as api from '../api';
import { actionTypes } from 'redux-resource';
import { PER_PAGE } from '../helpers/viewPurchase';
import NetworkError from '../helpers/networkErrorClass';
import { SubmissionError } from 'redux-form';

export const fetchCustomPlanPricing = (id) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'customPlans',
    requestKey: `fetchCustomPlanPricing`,
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_PENDING,
  });

  return api
    .fetchCustomPlanPricing(id)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_SUCCEEDED,
        resources: [response.data],
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_FAILED,
        requestProperties: {
          message: err.response && err.response.details,
        },
      });
    });
};

export const fetchCustomPlanPricingList =
  (page = 1, search = {}) =>
  (dispatch) => {
    const actionDefaults = {
      resourceType: 'customPlans',
      requestKey: `fetchCustomPlanPricingList${page}`,
      list: `fetchCustomPlanPricingList${page}`,
      mergeListIds: false,
    };

    dispatch({
      ...actionDefaults,
      type: actionTypes.READ_RESOURCES_PENDING,
    });

    return api
      .fetchCustomPlanPricingList(page, search)
      .then((response) => {
        const { count, next, previous, results = [] } = response.data;

        dispatch({
          ...actionDefaults,
          type: actionTypes.READ_RESOURCES_SUCCEEDED,
          resources: results,
          requestProperties: {
            perPage: (results && results.length) || PER_PAGE,
            count,
            next,
            previous,
          },
        });
      })
      .catch((err) => {
        dispatch({
          ...actionDefaults,
          type: actionTypes.READ_RESOURCES_FAILED,
          requestProperties: {
            message: err.response && err.response.details,
          },
        });
      });
  };

export const createCustomPlanPricing = (attrs) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'customPlans',
    requestKey: `createCustomPlanPricing`,
    list: 'createCustomPlanPricing',
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.CREATE_RESOURCES_PENDING,
  });

  return api
    .createCustomPlanPricing(attrs)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.CREATE_RESOURCES_SUCCEEDED,
        resources: [response.data],
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.CREATE_RESOURCES_FAILED,
      });

      let messages = err.response
        ? err.response.data
        : { detail: 'Something went wrong' };
      throw new SubmissionError(messages);
    });
};

export const updateCustomPlanPricing = (planId, attrs) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'customPlans',
    requestKey: 'updateCustomPlanPricing',
    list: 'updateCustomPlanPricing',
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.UPDATE_RESOURCES_PENDING,
  });

  return api
    .updateCustomPlanPricing(planId, attrs)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.UPDATE_RESOURCES_SUCCEEDED,
        resources: [response.data],
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.UPDATE_RESOURCES_FAILED,
      });

      let messages = err.response
        ? err.response.data
        : { detail: 'Something went wrong' };
      throw new NetworkError(messages);
    });
};

export const deleteCustomPlanPricing = (planId) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'customPlans',
    requestKey: 'deleteCustomPlanPricing',
    list: 'deleteCustomPlanPricing',
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.DELETE_RESOURCES_PENDING,
  });

  return api
    .deleteCustomPlanPricing(planId)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.DELETE_RESOURCES_SUCCEEDED,
        resources: [response.data],
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.DELETE_RESOURCES_FAILED,
      });

      let messages = err.response
        ? err.response.data
        : { detail: 'Something went wrong' };
      throw new NetworkError(messages);
    });
};

export const fetchUserCustomPlans = (userId) => async (dispatch) => {
  let customPlans = [];
  let page = 1;
  let next = 'next-url';

  const actionDefaults = {
    resourceType: 'customPlans',
    requestKey: `fetchUserCustomPlanPricingList`,
    list: `fetchUserCustomPlanPricingList`,
    mergeListIds: false,
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_PENDING,
  });

  while (next) {
    let response;

    try {
      response = await api.fetchCustomPlanPricingList(page, {
        user_profile: userId,
        is_effective: true,
        is_visible: true,
      });
    } catch (e) {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_FAILED,
        requestProperties: {
          message: e.response && e.response.details,
        },
      });
      let messages = e.response
        ? e.response.data
        : { detail: 'Something went wrong' };
      throw new SubmissionError({
        _error: messages,
      });
    }

    customPlans = customPlans.concat(response.data.results);
    next = response.data.next;
    page += 1;
  }

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_SUCCEEDED,
    resources: customPlans,
  });

  return customPlans;
};
